// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export let ArrayUtils = function () { };

ArrayUtils.RemoveElementFromArray = function (array, element)
{
    var remIndex = array.indexOf(element);
    if (remIndex !== -1)
    {
        array.splice(remIndex, 1)
        return true;
    }
    return false;
};